/**
 * SpaContextServiceModule — pushes the Briefing Room's on-screen snapshot to
 * the host (vibe-designer) so its voice ("BRIDGE") and Pi agents can SEE the
 * module (2026-07-01).
 *
 * Transport is the same window-event bus the host already uses for host↔module
 * control (`vibe:module-action`, `vibe:focus-panel`): the module + host share
 * one window (M3a alias direct-source import), so a CustomEvent reaches the
 * host without this package importing anything from vibe-designer. The host
 * listens for `vibe:spa-context` / `vibe:spa-context-clear` and forwards to its
 * spaContextStore, gated on the Briefing Room actually being the visible view.
 */
import type { SpaContextService, SpaContextSnapshot } from '../types';

export const SPA_CONTEXT_EVENT = 'vibe:spa-context';
export const SPA_CONTEXT_CLEAR_EVENT = 'vibe:spa-context-clear';

export class SpaContextServiceModule implements SpaContextService {
  publish(snapshot: SpaContextSnapshot): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(SPA_CONTEXT_EVENT, { detail: snapshot }));
  }

  clear(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(SPA_CONTEXT_CLEAR_EVENT));
  }
}
